var _rect, _rect2, _rect3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForms1C12A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 48,
    viewBox: "0 0 168 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 48,
    rx: 5.17736,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3607,
    y: 12.8288,
    width: 22.6529,
    height: 22.6529,
    rx: 11.3264,
    stroke: "#5568FE",
    strokeWidth: 1.65753
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.952,
    y: 16.4204,
    width: 15.4703,
    height: 15.4703,
    rx: 7.73513,
    fill: "#5568FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3119 29.5889V27.9623H53.389V17.0535H51.6563V29.5889H59.3119ZM60.4235 27.3081C60.4235 28.6518 61.5374 29.8541 63.2701 29.8541C64.7906 29.8541 65.6392 29.0408 66.0105 28.4396C66.0105 29.0585 66.0635 29.3767 66.0989 29.5889H67.7255C67.6901 29.3767 67.6194 28.9347 67.6194 28.1921V23.9312C67.6194 22.2692 66.6293 20.8194 64.0833 20.8194C62.2446 20.8194 60.7771 21.951 60.6003 23.5776L62.1916 23.9489C62.2976 22.9588 62.9518 22.2339 64.1187 22.2339C65.4094 22.2339 65.9575 22.9234 65.9575 23.7544C65.9575 24.0549 65.816 24.3201 65.3033 24.3909L63.0049 24.7268C61.5374 24.9389 60.4235 25.7876 60.4235 27.3081ZM63.4999 28.4573C62.6512 28.4573 62.1208 27.8562 62.1208 27.2197C62.1208 26.4595 62.6512 26.0528 63.3585 25.9467L65.9575 25.5578V25.9467C65.9575 27.8032 64.8613 28.4573 63.4999 28.4573ZM71.8881 29.5889V28.3512C72.4185 29.2706 73.3909 29.8187 74.6462 29.8187C77.1745 29.8187 78.6066 27.8208 78.6066 25.2926C78.6066 22.8173 77.2806 20.8371 74.6993 20.8371C73.2848 20.8371 72.2947 21.5267 71.8881 22.2869V16.7883H70.2438V29.5889H71.8881ZM76.9093 25.2926C76.9093 27.1313 75.9192 28.3336 74.3987 28.3336C72.9312 28.3336 71.8704 27.1313 71.8704 25.2926C71.8704 23.4538 72.9312 22.3046 74.3987 22.3046C75.9369 22.3046 76.9093 23.4538 76.9093 25.2926ZM81.9438 24.4616C82.0145 23.3654 82.8631 22.2869 84.2599 22.2869C85.7627 22.2869 86.5583 23.2416 86.5937 24.4616H81.9438ZM86.8412 26.6716C86.523 27.6264 85.8334 28.3866 84.4544 28.3866C83.0223 28.3866 81.9261 27.3258 81.8907 25.8053H88.291C88.3087 25.6992 88.3263 25.487 88.3263 25.2749C88.3263 22.6228 86.8589 20.8194 84.2422 20.8194C82.1029 20.8194 80.1757 22.6405 80.1757 25.3102C80.1757 28.1921 82.1736 29.8541 84.4544 29.8541C86.4346 29.8541 87.7959 28.6695 88.2733 27.1667L86.8412 26.6716ZM92.0724 29.5889V16.7883H90.4104V29.5889H92.0724Z",
    fill: "#14121D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms1C12A);
export default __webpack_public_path__ + "static/media/forms1c12a.eb50b658e76f079a14efea882465416e.svg";
export { ForwardRef as ReactComponent };